import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";
import { useFormik } from "formik";
import TextField from "@material-ui/core/TextField";
import { KeyboardDatePicker } from "@material-ui/pickers";
import Rating from "@material-ui/lab/Rating";
import Box from "@material-ui/core/Box";

import { DOCS_FORMATS, IMAGES_FORMATS, MAX_FILE_SIZE } from "../../constants/constants";

import Error from "../../components/error";
import Button from "../../components/button";
import ICInput from "../../components/form/input";
import ICPhoneInput from "../../components/form/phoneInput";
import ICMaskInput from "../../components/form/customMaskInput";
import ICCheckbox from "../../components/form/checkbox";
import CustomModal from "../../components/modal";
import ViewProfilePic from "../../components/viewProfilePic";
import DocImgView from "../../components/docImgView";
import RefreshButton from "../../components/refreshButton";
import HistoryRecordButton from "../../components/historyRecordButton";
import Loader from "../../components/loader";

import { checkEmptyElementInObj } from "../../utils/commonMethods";

import HIServiceType from "../../constants/HI_API";

import HPIIHistoryRecord from "../../containers/HIServiceInterface/HPIIHistoryRecord";

import {
  checkDuplicateDoctorDemographicInfoApiRoute,
  checkIsDuplicateHPIINumberApiRoute,
  getHPIIHistoryRecordApiRoute,
  requestHIServiceSearchHPIIApiRoute
} from "../../apiRoutes";

import MakeAPICall from "../../apiCalls/common";

import ICTempImg from "../../assets/images/noimg.png";

const initialValues = {
  profilePicFile: null,
  photoIdFile: null,
  abnDocFile: null,
  ahpDocFile: null,
  medProNoDocFile: null,
  pndDocFile: null,
  piipdDocFile: null,
  AUTH_PRESCRIBER_SCHEMA_DOCDoc: null,
  AUTH_PRESCRIBER_SCHEMA_DOCDoc_MC: null,
  sigatureDocFile: null,
  eRxDocFile: null,
  ssaDocFile: null,
  uin: "",
  appDate: "",
  rejDate: "",
  approvalDate: "",
  fname: "",
  fnameForHIService: "",
  mname: "",
  lname: "",
  dob: new Date(),
  gender: "",
  phoneNo: "",
  email: "",
  qualifications: "",
  un: "",
  streetName: "",
  suburb: "",
  state: "",
  postCode: "",
  profilePic: ICTempImg,
  photoId: ICTempImg,
  abn: "",
  abnFile: ICTempImg,
  abnFileName: "",
  ahp: "",
  ahpFile: ICTempImg,
  ahpFileName: "",
  medProvNo: "",
  medProNoFile: ICTempImg,
  medProNoFileName: "",
  presNo: "",
  pndFileName: "",
  pndFile: ICTempImg,
  authPrescriberSchemaNo: "",
  authPrescriberSchemaNoMC: "",
  AUTH_PRESCRIBER_SCHEMA_DOC_NAME: "",
  AUTH_PRESCRIBER_SCHEMA_DOC_NAME_MC: "",
  AUTH_PRESCRIBER_SCHEMA_DOC: ICTempImg,
  AUTH_PRESCRIBER_SCHEMA_DOC_MC: ICTempImg,
  eRxId: "",
  eRxFile: ICTempImg,
  eRxFileName: "",
  piip: "",
  piipdFile: ICTempImg,
  piipdFileName: "",
  sigatureFile: ICTempImg,
  ssaFile: ICTempImg,
  ssaFileName: "",
  additionalApplication: "",
  addNoForDoctor: "",
  template1Checkbox: false,
  canTakeMedicareConsult: false,
  isAccessToInstantSwitch: false,
  template2Checkbox: false,
  contactName1: "",
  contactName2: "",
  contactNo1: "",
  contactNo2: "",
  rating: 0,
  HPIINumber: "",
  HPIIStatus: "",
  optOutMarketingEmails: false,
  isAccessToInstantHush: false,
  isAccessToInstantSwitchMC: false // pin: "",
  // passwordFailCounter: ""
};

const DoctorProfileForm = props => {
  const [profileData, setProfileData] = useState(initialValues);
  const [showPicModal, setShowPicModal] = useState(false);
  const [selPic, setSelPic] = useState(ICTempImg);
  const [picModalTitle, setPicModalTitle] = useState("View Pic");
  const [profilePicFileErr, setProfilePicFileErr] = useState("");
  const [photoIdFileErr, setPhotoIdFileErr] = useState("");
  const [abnDocFileErr, setAbnDocFileErr] = useState("");
  const [ahpDocFileErr, setAhpDocFileErr] = useState("");
  const [medProNoDocFileErr, setMedProNoDocFileErr] = useState("");
  const [pndDocFileErr, setPndDocFileErr] = useState("");
  const [AUTH_PRESCRIBER_SCHEMA_DOCDocErr, setAUTH_PRESCRIBER_SCHEMA_DOCDocErr] = useState("");
  const [AUTH_PRESCRIBER_SCHEMA_DOCDocMCErr, setAUTH_PRESCRIBER_SCHEMA_DOCDocMCErr] = useState("");
  const [piipdDocFileErr, setPiipdDocFileErr] = useState("");
  const [sigatureDocFileErr, setSigatureDocFileErr] = useState("");
  const [eRxDocFileErr, setERxDocFileErr] = useState("");
  const [ssaDocFileErr, setSsaDocFileErr] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [serverErrorMsg, setServerErrorMsg] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  // const [HPIIInfo, setHPIIInfo] = useState({ HPIINumber: "", HPIIStatus: "" });
  const [HPIIDuplicateModal, setHPIIDuplicateModal] = useState(false);
  const [HPIIDuplicateModalText, setHPIIDuplicateModalText] = useState("");
  const [HPIIHistoryRecordModal, setHPIIHistoryRecordModal] = useState(false);
  const [HPIIHistoryRecordData, setHPIIHistoryRecordData] = useState(null);
  const [HPIICacheOfNameAndAHPRA, setHPIICacheOfNameAndAHPRA] = useState({});
  // const [passwordFailCounter, setPasswordFailCounter] = useState(0);

  useEffect(() => {
    let data = {
      profilePicFile: null,
      photoIdFile: null,
      abnDocFile: null,
      ahpDocFile: null,
      medProNoDocFile: null,
      pndDocFile: null,
      AUTH_PRESCRIBER_SCHEMA_DOCDoc: null,
      AUTH_PRESCRIBER_SCHEMA_DOCDoc_MC: null,
      piipdDocFile: null,
      sigatureDocFile: null,
      eRxDocFile: null,
      ssaDocFile: null
    };

    if (props.data !== null) {
      data.uin = props.data.uin;
      data.appDate = props.data.appDate;
      data.rejDate = props.data.rejDate;
      data.approvalDate = props.data.approvalDate;
      data.fname = props.data.fname;
      data.fnameForHIService = props.data.firstNameForHIService || props.data.fname;
      data.mname = props.data.mname;
      data.lname = props.data.lname;
      data.dob = props.data.dob;
      data.gender = props.data.gender;
      data.phoneNo = props.data.phoneNo;
      data.email = props.data.email;
      data.qualifications = props.data.qualifications;
      data.un = props.data.un;
      data.streetName = props.data.streetName;
      data.suburb = props.data.suburb;
      data.state = props.data.state;
      data.postCode = props.data.postCode;
      data.profilePic = props.data.profilePic !== "" ? props.data.profilePic : ICTempImg;
      data.photoId = props.data.photoId !== "" ? props.data.photoId : ICTempImg;
      data.abn = props.data.abn;
      data.abnFile = props.data.abnFile !== "" ? props.data.abnFile : ICTempImg;
      data.abnFileName = props.data.abnFileName;
      data.ahp = props.data.ahp;
      data.ahpFile = props.data.ahpFile !== "" ? props.data.ahpFile : ICTempImg;
      data.ahpFileName = props.data.ahpFileName;
      data.medProvNo = props.data.medProvNo;
      data.medProNoFile = props.data.medProNoFile !== "" ? props.data.medProNoFile : ICTempImg;
      data.medProNoFileName = props.data.medProNoFileName;
      data.presNo = props.data.presNo;
      data.authPrescriberSchemaNo = props.data.authPrescriberSchemaNo;
      data.authPrescriberSchemaNoMC = props.data.authPrescriberSchemaNoMC;
      data.pndFileName = props.data.pndFileName;
      data.pndFile = props.data.pndFile !== "" ? props.data.pndFile : ICTempImg;
      data.AUTH_PRESCRIBER_SCHEMA_DOC_NAME = props.data.AUTH_PRESCRIBER_SCHEMA_DOC_NAME;
      data.AUTH_PRESCRIBER_SCHEMA_DOC = props.data.AUTH_PRESCRIBER_SCHEMA_DOC !== "" ? props.data.AUTH_PRESCRIBER_SCHEMA_DOC : ICTempImg;
      data.AUTH_PRESCRIBER_SCHEMA_DOC_NAME_MC = props.data.AUTH_PRESCRIBER_SCHEMA_DOC_NAME_MC;
      data.AUTH_PRESCRIBER_SCHEMA_DOC_MC = props.data.AUTH_PRESCRIBER_SCHEMA_DOC_MC !== "" ? props.data.AUTH_PRESCRIBER_SCHEMA_DOC_MC : ICTempImg;
      data.eRxId = props.data.eRxId;
      data.eRxFile = props.data.eRxFile !== "" ? props.data.eRxFile : ICTempImg;
      data.eRxFileName = props.data.eRxFileName;
      data.piip = props.data.piip;
      data.piipdFile = props.data.piipdFile !== "" ? props.data.piipdFile : ICTempImg;
      data.piipdFileName = props.data.piipdFileName;
      data.sigatureFile = props.data.sigatureFile ? props.data.sigatureFile : ICTempImg;
      data.ssaFile = props.data.ssaFile ? props.data.ssaFile : ICTempImg;
      data.ssaFileName = props.data.ssaFileName;
      data.additionalApplication = props.data.additionalApplication;
      data.addNoForDoctor = props.data.addNoForDoctor;
      data.template1Checkbox = props.data.template1Checkbox;
      data.canTakeMedicareConsult = props.data.canTakeMedicareConsult;
      data.isAccessToInstantSwitch = props.data.isAccessToInstantSwitch ? props.data.isAccessToInstantSwitch : false; // instant switch access grant or not
      data.isAccessToInstantHush = props.data.isAccessToInstantHush ? props.data.isAccessToInstantHush : false; // instant hush access grant or not
      data.isAccessToInstantSwitchMC = props.data.isAccessToInstantSwitchMC ? props.data.isAccessToInstantSwitchMC : false; // instant hush access grant or not
      // data.template2Checkbox = props.data.template2Checkbox;
      data.template2Checkbox = false;
      data.contactName1 = props.data.contactName1;
      data.contactName2 = props.data.contactName2;
      data.contactNo1 = props.data.contactNo1;
      data.contactNo2 = props.data.contactNo2;
      data.rating = parseFloat(props.data.rating);
      data.HPIINumber = props.data.HPIINumber ? props.data.HPIINumber : "";
      data.HPIIStatus = props.data.HPIIStatus ? props.data.HPIIStatus === "A" ? "Active" : props.data.HPIIStatus === "D" ? "Deactivated" : props.data.HPIIStatus === "R" ? "Retired" : props.data.HPIIStatus : "";
      data.HPIIUpdatedAt = props.data.HPIIUpdatedAt ? props.data.HPIIUpdatedAt : "";
      data.optOutMarketingEmails = !!props.data.optOutMarketingEmails;
      data.instantSwitchBio = props.data.instantSwitchBio;
      data.instantLeafBio = props.data.instantLeafBio;
      data.instantHushBio = props.data.instantHushBio;

      // data.pin = props.data.pin || "0000";
      // data.passwordFailCounter = props.data.passwordFailCounter || "0";
      setProfileData(data);
      setHPIICacheOfNameAndAHPRA({
        fname: data.fnameForHIService, lname: data.lname, ahp: data.ahp
      });
    }
  }, [props.data]);

  const showSelPicModal = pic => {
    setSelPic(pic);
    setShowPicModal(true);
  };

  let validationSchema = {
    fname: Yup.string()
      .min(2, "First Name must be of minimum length 2")
      .max(25, "First Name cannot be greater than 25 characters")
      .required("Please enter First Name"),
    fnameForHIService: Yup.string()
      .min(2, "First Name must be of minimum length 2")
      .max(25, "First Name cannot be greater than 25 characters")
      .required("Please enter First Name"),
    lname: Yup.string()
      .min(2, "Last Name must be of minimum length 2")
      .max(25, "Last Name cannot be greater than 25 characters")
      .required("Please enter Last Name"),
    dob: Yup.mixed().required("Please select Date of Birth"),
    gender: Yup.string().required("Please select Gender"),
    state: Yup.string().required("Please select State"),
    phoneNo: Yup.string().required("Please enter Mobile Number"),
    email: Yup.string()
      .min(7, "Email Address must be of minimum length 7")
      .email("Please provide a valid Email Address")
      .required("Please enter Email Address"),
    un: Yup.string().required("Please enter Street Number"),
    streetName: Yup.string().required("Please enter Street Name"),
    suburb: Yup.string().required("Please enter Suburb"),
    postCode: Yup.string().required("Please enter Postcode"), // pin: Yup.string()
    //   .matches(/^[0-9]{4}$/, "PIN Number must be of length 4 digits")
    //   .required("Please enter PIN Number")
    instantHushBio: Yup.string().when("isAccessToInstantHush", {
      is: true, then: Yup.string().required("Field is required"), otherwise: Yup.string()
    }),
    instantSwitchBio: Yup.string().when("isAccessToInstantSwitch", {
      is: true, then: Yup.string().required("Field is required"), otherwise: Yup.string()
    }),
    instantLeafBio: Yup.string().when("isAccessToInstantSwitchMC", {
      is: true, then: Yup.string().required("Field is required"), otherwise: Yup.string()
    })
  };

  // mandatory in approved profile
  if (props.isApprovedProfile) {
    validationSchema.qualifications = Yup.string().required("Please enter Qualifications");
    validationSchema.abn = Yup.string().required("Please enter ABN");
    validationSchema.ahp = Yup.string().required("Please enter AHPRA");
    validationSchema.medProvNo = Yup.string().required("Please enter Medicare Provider Number");
    validationSchema.presNo = Yup.string().required("Please enter Prescriber Number");
    validationSchema.piip = Yup.string().required("Please enter Professional Indemnity Insurance Policy");
    validationSchema.eRxId = Yup.string().required("Please enter eRx ID");
  }

  // validate input file
  const validateFile = (file, field, isPdfSupported = false) => {
    let error = "";
    if (file) {
      if (file.size >= MAX_FILE_SIZE) {
        error = "Maximum 2MB file is allowed";
      } else if (!isPdfSupported && !IMAGES_FORMATS.includes(file.type)) {
        error = "File must be one of these formats only jpg, png or svg";
      } else if (isPdfSupported && !DOCS_FORMATS.includes(file.type)) {
        error = "File must be one of these formats only jpg, png, svg or pdf";
      }
    }

    if (field === "profilePicFile") {
      setProfilePicFileErr(error);
    }
    if (field === "photoIdFile") {
      setPhotoIdFileErr(error);
    }
    if (field === "abnDocFile") {
      setAbnDocFileErr(error);
    }
    if (field === "ahpDocFile") {
      setAhpDocFileErr(error);
    }
    if (field === "medProNoDocFile") {
      setMedProNoDocFileErr(error);
    }
    if (field === "pndDocFile") {
      setPndDocFileErr(error);
    }
    if (field === "AUTH_PRESCRIBER_SCHEMA_DOCDoc") {
      setAUTH_PRESCRIBER_SCHEMA_DOCDocErr(error);
    }
    if (field === "AUTH_PRESCRIBER_SCHEMA_DOCDoc_MC") {
      setAUTH_PRESCRIBER_SCHEMA_DOCDocMCErr(error);
    }
    if (field === "piipdDocFile") {
      setPiipdDocFileErr(error);
    }
    if (field === "sigatureDocFile") {
      setSigatureDocFileErr(error);
    }
    if (field === "eRxDocFile") {
      setERxDocFileErr(error);
    }
    if (field === "ssaDocFile") {
      setSsaDocFileErr(error);
    }
    if (error !== "") {
      return false;
    }
    return true;
  };

  const previewUploadDoc = file => {
    console.log("Got the file: -> ", file);
    if (file && file.type === "application/pdf") {
      return file.name;
    } else {
      return URL.createObjectURL(file);
    }
  };

  let diffProfileViewCSS = "form-group col-md-6";
  if (props.isRejectedProfile || props.isApprovedProfile) {
    diffProfileViewCSS = "form-group col-md-4";
  }

  const checkDuplicateDoctorDemographicInfo = values => {
    const HPIIObj = {
      firstName: values.fnameForHIService, lastName: values.lname, AHPRARegistrationID: values.ahp
    };
    const emptyElementArray = checkEmptyElementInObj(HPIIObj);
    if (emptyElementArray.length !== 0) {
      let emptyElements = "";
      emptyElementArray.forEach(item => (emptyElements = emptyElements + " " + item));
      setModalTitle("HPII Validation");
      setModalText(`Please check personal information before HPII validation. <br/> 
          These following fields must be provided:"First Name", "Last Name", "Australian Health Practitioners Regulation Agency (AHPRA)".`);
      setShowModal(true);
    } else {
      const formData = new FormData();
      formData.append("doctorID", props.data._id);
      formData.append("firstName", values.fnameForHIService);
      formData.append("lastName", values.lname);
      formData.append("AHPRARegistrationID", values.ahp);

      setIsProcessing(true);
      setApiCallParams({
        reqType: "POST",
        reqUrl: checkDuplicateDoctorDemographicInfoApiRoute,
        dataObj: formData,
        successCallback: res => {
          setIsProcessing(false);
          const result = res.data.data;
          const duplicateDoctorCount = Object.keys(result).length;
          if (duplicateDoctorCount > 1) {
            let duplicateDoctorUIN = "";
            result.forEach(item => {
              duplicateDoctorUIN = duplicateDoctorUIN + item.doctorId + " ";
            });
            setModalTitle("Duplicate Doctor Accounts");
            setModalText("There are " + duplicateDoctorCount + " duplicate doctor accounts. <br /> Doctor UIN: " + duplicateDoctorUIN + "<br />Please remove the duplicate accounts first.");
            setShowModal(true);
          } else if (duplicateDoctorCount === 1) {
            let duplicateDoctorUIN = "";
            result.forEach(item => {
              duplicateDoctorUIN = duplicateDoctorUIN + item.doctorId + " ";
            });
            setModalTitle("Duplicate Doctor Accounts");
            setModalText("There is 1 duplicate doctor account. <br /> Doctor UIN: " + duplicateDoctorUIN + "<br />Please remove the duplicate account first.");
            setShowModal(true);
          } else {
            // search HPII number if there is no duplicate doctor account
            searchHPII(values);
          }
        },
        failureCallback: err => {
          setIsProcessing(false);
          //setServerErrorMsg(err.message);
        }
      });
    }
  };

  const showHPIIHistory = () => {
    const doctorID = props.data._id;

    setIsProcessing(true);
    setApiCallParams({
      reqType: "GET", reqUrl: getHPIIHistoryRecordApiRoute, params: { doctorID }, successCallback: res => {
        setIsProcessing(false);
        console.log("showHPIIHistory res", res);
        setHPIIHistoryRecordData(res.data.data);
        setHPIIHistoryRecordModal(true);
      }, failureCallback: err => {
        setIsProcessing(false);
        //setServerErrorMsg(err.message);
      }
    });
  };

  const searchHPII = values => {
    const HPIIObj = {
      firstName: values.fnameForHIService, lastName: values.lname, AHPRARegistrationID: values.ahp
    };

    setHPIICacheOfNameAndAHPRA({
      fname: values.fnameForHIService, lname: values.lname, ahp: values.ahp
    });

    const emptyElementArray = checkEmptyElementInObj(HPIIObj);
    if (emptyElementArray.length === 0) {
      HPIIObj.doctorID = props.data._id;
      HPIIObj.serviceType = HIServiceType.SEARCH_FOR_PROVIDER_INDIVIDUAL;

      console.log("HPIIObj", HPIIObj);

      // const formData = new FormData();
      // formData.append("HIInfo", JSON.stringify(HPIIObj));
      const dataToSend = {
        HIInfo: HPIIObj
      };

      setIsProcessing(true);
      setApiCallParams({
        reqType: "POST", reqUrl: requestHIServiceSearchHPIIApiRoute, dataObj: dataToSend, successCallback: res => {
          setIsProcessing(false);
          console.log("requestHIServiceSearchHPIIApiRoute res", res.data.data);
          if (res && res.data && res.data.data && res.data.data.searchForProviderIndividualResult) {
            // searchForProviderIndividualResult in the response
            const { isAlert, alertMessage, HPIIUpdatedAt } = res.data.data;
            const searchForProviderIndividualResult = res.data.data.searchForProviderIndividualResult;
            const {
              hpiiNumber, status: HPIIStatus
            } = searchForProviderIndividualResult;

            let isHPIIChanged = false;
            if (hpiiNumber) {
              // there is a HPII Number in response

              const HPIINumber = hpiiNumber.split("/id/hi/hpii/1.0/")[1];

              isHPIIChanged = formik.values.HPIINumber !== HPIINumber;

              formik.values.HPIINumber = HPIINumber;
              switch (HPIIStatus) {
                case "A":
                  formik.values.HPIIStatus = "Active";
                  break;
                case "D":
                  formik.values.HPIIStatus = "Deactivated";
                  break;
                case "R":
                  formik.values.HPIIStatus = "Retired";
                  break;
                default:
                  formik.values.HPIIStatus = HPIIStatus;
                  break;
              }
              formik.values.HPIIUpdatedAt = HPIIUpdatedAt;

              const formData = new FormData();
              formData.append("doctorID", props.data._id);
              formData.append("HPIINumber", HPIINumber);

              setIsProcessing(true);
              setApiCallParams({
                reqType: "POST",
                reqUrl: checkIsDuplicateHPIINumberApiRoute,
                dataObj: formData,
                successCallback: res => {
                  setIsProcessing(false);
                  const result = res.data.data;
                  const duplicateHPIICount = Object.keys(result).length;
                  if (duplicateHPIICount > 0) {
                    // there are duplicate HPII Number in DB
                    let duplicateHPIIDoctorUIN = "";
                    result.map(item => {
                      duplicateHPIIDoctorUIN = duplicateHPIIDoctorUIN + item.doctorId + " ";
                    });
                    setHPIIDuplicateModalText("HPII details have been changed and saved. <br/>Check HPII history record to compare HPII changes." + "<br/><br/>Attention: There are " + duplicateHPIICount + "doctor accounts with the same HPII Number. <br /> Doctor UIN: " + duplicateHPIIDoctorUIN + "<br/>Please check and report to HI Service for more information.");
                    setHPIIDuplicateModal(true);
                  }
                },
                failureCallback: err => {
                  setIsProcessing(false);
                  //setServerErrorMsg(err.message);
                }
              });
            }

            // check if there are serviceMessages from HI request, if not check isAlert
            if (searchForProviderIndividualResult.serviceMessages && searchForProviderIndividualResult.serviceMessages.serviceMessage) {
              const isHPIIChanged = !!formik.values.HPIINumber && !!formik.values.HPIIStatus;
              formik.values.HPIINumber = "";
              formik.values.HPIIStatus = "";
              formik.values.HPIIUpdatedAt = HPIIUpdatedAt;
              const serviceMessage = searchForProviderIndividualResult.serviceMessages.serviceMessage;
              setModalTitle("HPII Validation");
              setModalText(isHPIIChanged ? `<p>Attention: HPII has been changed.</p>
                  <p style=color:#f00>${removeSpecificWordFromHIResponse(serviceMessage.reason)}</p>` : `<p style=color:#f00>${removeSpecificWordFromHIResponse(serviceMessage.reason)}</p>`);
              setShowModal(true);
            } else if (isAlert) {
              let text = removeSpecificWordFromHIResponse(alertMessage);
              switch (HPIIStatus) {
                case "D":
                  text = "The record contains a DEACTIVATED HPII Status.";
                  break;
                case "R":
                  text = "The record contains a RETIRED HPII Status.";
                  break;
                default:
                  break;
              }
              setModalTitle("HPII Validation");
              setModalText(`<p style=color:#f00>${text}</p>`);
              setShowModal(true);
            } else {
              setModalTitle("HPII Validation");
              setModalText(isHPIIChanged ? `<p>Attention: HPII has been changed. Check access logs for details.</p><p style=color:#28a745>HPII successfully validated.<p/>` : `<p style=color:#28a745>HPII successfully validated.<p/>`);
              setShowModal(true);
            }
          } else {
            setModalTitle("HPII Validation");
            setModalText(`Something went wrong. <br/>Please try it again later.`);
            setShowModal(true);
          }
        }, failureCallback: err => {
          setIsProcessing(false);
          //setServerErrorMsg(err.message);
        }
      });
    } else {
      let emptyElements = "";
      emptyElementArray.forEach(item => (emptyElements = emptyElements + " " + item));
      setModalTitle("HPII Validation");
      setModalText(`Please check personal information before HPII validation. <br/> 
          These following fields must be provided: "Last Name", "Australian Health Practitioners Regulation Agency (AHPRA)".`);
      setShowModal(true);
    }
  };

  const removeSpecificWordFromHIResponse = str => {
    const newStr = str.replace(/\(INFORMATION\)\s*|\(ERROR\)\s*/g, "");
    return newStr;
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: profileData,
    validationSchema: Yup.object(validationSchema),
    onSubmit: values => {
      // check if name or AHPRA has been changed
      const isHPIICriteriaChanged = checkIsHPIICriteriaChangedBeforeSave();
      if (isHPIICriteriaChanged) {
        setModalTitle("Validate HPII before saving");
        setModalText(`Please validate HPII before saving as doctor's name or AHPRA has been changed.<br/> `);
        setShowModal(true);
      } else {
        props.onSubmitForm(values);
      }
    }
  });

  const handleClickCancel = () => {
    const isHPIICriteriaChanged = checkIsHPIICriteriaChangedBeforeCancel();
    if (isHPIICriteriaChanged) {
      setModalTitle("Validate HPII before cancelling");
      setModalText(`Please validate HPII again before cancelling, using the initial first name ${props.data.firstNameForHIService || props.data.fname}, last name: ${props.data.lname} and AHPRA: ${props.data.ahp}<br/> `);
      setShowModal(true);
    } else {
      props.onCancelForm();
    }
  };

  const checkIsHPIICriteriaChangedBeforeSave = () => {
    const { fname, lname, ahp } = HPIICacheOfNameAndAHPRA;
    if (fname === formik.values.fnameForHIService && lname === formik.values.lname && ahp === formik.values.ahp) {
      return false;
    } else {
      return true;
    }
  };

  const checkIsHPIICriteriaChangedBeforeCancel = () => {
    const { fname, lname, ahp } = HPIICacheOfNameAndAHPRA;
    if (fname === (props.data.firstNameForHIService || props.data.fname) && lname === props.data.lname && ahp === props.data.ahp) {
      return false;
    } else {
      return true;
    }
  };

  return (<Fragment>
    {isProcessing && <Loader />}
    <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
      <CustomModal
        openModal={showPicModal}
        cancelEvent={() => setShowPicModal(false)}
        title={picModalTitle}
        modalBodyContent={<ViewProfilePic profileImg={selPic} />}
        noFooterButtons={true}
      />
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showModal}
        title={modalTitle}
        className="text-left"
        cancelEvent={() => {
          setShowModal(false);
          setModalText("");
        }}
        modalBodyContent={<p
          className="mb-0"
          dangerouslySetInnerHTML={{
            __html: modalText
          }}
        ></p>}
      />
      <CustomModal
        openModal={HPIIDuplicateModal}
        cancelText="OKAY"
        cancelEvent={() => {
          setHPIIDuplicateModal(false);
          setHPIIDuplicateModalText("");
        }}
        title="HPII Number Duplicate Information"
        modalBodyContent={<p
          className="mb-0"
          dangerouslySetInnerHTML={{
            __html: HPIIDuplicateModalText
          }}
        ></p>}
        useOneButton={true}
      />
      <CustomModal
        openModal={HPIIHistoryRecordModal}
        cancelEvent={() => {
          setHPIIHistoryRecordModal(false);
        }}
        title="HPII Access Logs"
        modalBodyContent={<HPIIHistoryRecord HPIIHistoryRecordData={HPIIHistoryRecordData} />}
        size="lg"
        useOneButton={true}
        cancelText="Close"
        noFooterButtons={true}
      />
      <div className="form-row mt-4">
        <div className={diffProfileViewCSS}>
          <label>UIN</label>
          <ICInput
            name="uin"
            type="text"
            value={formik.values.uin}
            disabled
          />
        </div>
        <div className={diffProfileViewCSS}>
          <label>Application Date</label>
          <ICInput
            name="appDate"
            type="text"
            value={formik.values.appDate}
            disabled
          />
        </div>
        {props.isRejectedProfile && (<div className="form-group col-md-4">
          <label>Rejection Date</label>
          <ICInput
            name="rejDate"
            type="text"
            value={formik.values.rejDate}
            disabled
          />
        </div>)}
        {props.isApprovedProfile && (<div className="form-group col-md-4">
          <label>Approval Date</label>
          <ICInput
            name="approvalDate"
            type="text"
            value={formik.values.approvalDate}
            disabled
          />
        </div>)}
      </div>
      {props.isApprovedProfile && (<React.Fragment>
        <div className="form-row mt-4">
          <div className="form-group col-md-4">
            <label>Average Star Rating</label>
            <Box component="fieldset" borderColor="transparent">
              <Rating
                name="rating"
                value={formik.values.rating}
                precision={0.5}
                readOnly
              />
            </Box>
          </div>
          <div className="form-group col-md-8">
            <label>Template Choices</label>
            <div className="row pl-3">
              <div className="col-md-3 d-flex flex-row align-items-md-start">
                <ICCheckbox
                  style={{ padding: 0 }}
                  name="template1Checkbox"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.template1Checkbox}
                  checked={formik.values.template1Checkbox}
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
                <p className="mb-0" style={{ marginLeft: "-10px" }}>
                  General Practice
                </p>
              </div>
              <div className="col-md-3 d-flex flex-row align-items-md-start">
                <ICCheckbox
                  style={{ padding: 0 }}
                  name="canTakeMedicareConsult"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.canTakeMedicareConsult}
                  checked={formik.values.canTakeMedicareConsult}
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
                <p className="mb-0" style={{ marginLeft: "-10px" }}>
                  Medicare
                </p>
              </div>
              <div className="col-md-3 d-flex flex-row align-items-md-start">
                <ICCheckbox
                  style={{ padding: 0 }}
                  name="isAccessToInstantSwitch"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.isAccessToInstantSwitch}
                  checked={formik.values.isAccessToInstantSwitch}
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
                <p className="mb-0" style={{ marginLeft: "-10px" }}>
                  Instant Switch
                </p>
              </div>
              <div className="col-md-3 d-flex flex-row align-items-md-start">
                <ICCheckbox
                  style={{ padding: 0 }}
                  name="isAccessToInstantSwitchMC"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.isAccessToInstantSwitchMC}
                  checked={formik.values.isAccessToInstantSwitchMC}
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
                <p className="mb-0" style={{ marginLeft: "-10px" }}>
                  Instant Leaf
                </p>
              </div>
              <div className="col-md-3 d-flex flex-row align-items-md-start">
                <ICCheckbox
                  style={{ padding: 0 }}
                  name="isAccessToInstantHush"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.isAccessToInstantHush}
                  checked={formik.values.isAccessToInstantHush}
                  inputProps={{ "aria-label": "primary checkbox" }}
                />
                <p className="mb-0" style={{ marginLeft: "-10px" }}>
                  Instant Hush
                </p>
              </div>
              {/* <div className="col-md-8 d-flex flex-row align-items-md-start">
                  <ICCheckbox
                    style={{ padding: 0 }}
                    name="template2Checkbox"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.template2Checkbox}
                    checked={formik.values.template2Checkbox}
                    inputProps={{ "aria-label": "primary checkbox" }}
                  />
                  <p className="mb-0" style={{ marginLeft: "-10px" }}>
                    Cosmetic Injectables & IV Therapy
                  </p>
                </div> */}
            </div>
          </div>
        </div>
      </React.Fragment>)}
      <div className="form-row mt-4">
        <div className="form-group col-md-3">
          <label>
            First Name
            <span className="error">*</span>
          </label>
          <ICInput
            name="fnameForHIService"
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.fnameForHIService}
            error={formik.touched.fnameForHIService && formik.errors.fnameForHIService ? true : false}
            helperText={formik.touched.fnameForHIService && formik.errors.fnameForHIService ? formik.errors.fnameForHIService : ""}
          />
        </div>
        <div className="form-group col-md-3">
          <label>
            First Name Display<span className="error">*</span>
          </label>
          <ICInput
            name="fname"
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.fname}
            error={formik.touched.fname && formik.errors.fname ? true : false}
            helperText={formik.touched.fname && formik.errors.fname ? formik.errors.fname : ""}
          />
        </div>
        <div className="form-group col-md-3">
          <label>Middle Name</label>
          <ICInput
            name="mname"
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.mname}
            error={formik.touched.mname && formik.errors.mname ? true : false}
            helperText={formik.touched.mname && formik.errors.mname ? formik.errors.mname : ""}
          />
        </div>
        <div className="form-group col-md-3">
          <label>
            Last Name <span className="error">*</span>
          </label>
          <ICInput
            name="lname"
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.lname}
            error={formik.touched.lname && formik.errors.lname ? true : false}
            helperText={formik.touched.lname && formik.errors.lname ? formik.errors.lname : ""}
          />
        </div>
      </div>
      <div className="form-row mt-4">
        <div className="form-group col-md-4">
          <label>
            Date of Birth <span className="error">*</span>
          </label>
          <br />
          <KeyboardDatePicker
            name="dob"
            autoOk
            className="w-100"
            variant="inline"
            mask="__-__-____"
            format="DD-MM-YYYY"
            value={formik.values.dob}
            onChange={date => {
              formik.setFieldValue("dob", date);
            }}
          />
        </div>
        <div className="form-group col-md-4">
          <label>
            Gender <span className="error">*</span>
          </label>
          <TextField
            name="gender"
            className="w-100"
            select
            value={formik.values.gender}
            SelectProps={{
              native: true
            }}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <option disabled value="0">
              Select Gender
            </option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </TextField>
        </div>
        <div className="form-group col-md-4">
          <label>
            Qualifications <span className="error">*</span>
          </label>
          <ICInput
            name="qualifications"
            type="text"
            value={formik.values.qualifications}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.qualifications && formik.errors.qualifications ? true : false}
            helperText={formik.touched.qualifications && formik.errors.qualifications ? formik.errors.qualifications : ""}
          />
        </div>
      </div>
      <div className="form-row mt-4">
        <div className="form-group col-md-6">
          <label>
            Email Address<span className="error">*</span>
          </label>
          <ICInput
            name="email"
            type="email"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.email}
            error={formik.touched.email && formik.errors.email ? true : false}
            helperText={formik.touched.email && formik.errors.email ? formik.errors.email : ""}
          />
        </div>
        <div className="form-group col-md-6">
          <label>
            Mobile Number <span className="error">*</span>
          </label>
          <ICPhoneInput
            name="phoneNo"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.phoneNo}
            error={formik.touched.phoneNo && formik.errors.phoneNo ? true : false}
            helperText={formik.touched.phoneNo && formik.errors.phoneNo ? formik.errors.phoneNo : ""}
            disabled={false}
          />
        </div>
      </div>
      <div className="form-row mt-4">
        <div className="form-group col-md-4">
          <label>
            Unit/Street Number <span className="error">*</span>
          </label>
          <ICInput
            name="un"
            type="text"
            value={formik.values.un}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.un && formik.errors.un ? true : false}
            helperText={formik.touched.un && formik.errors.un ? formik.errors.un : ""}
          />
        </div>
        <div className="form-group col-md-4">
          <label>
            Street Name <span className="error">*</span>
          </label>
          <ICInput
            name="streetName"
            type="text"
            value={formik.values.streetName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.streetName && formik.errors.streetName ? true : false}
            helperText={formik.touched.streetName && formik.errors.streetName ? formik.errors.streetName : ""}
          />
        </div>
        <div className="form-group col-md-4">
          <label>
            Suburb <span className="error">*</span>
          </label>
          <ICInput
            name="suburb"
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.suburb}
            error={formik.touched.suburb && formik.errors.suburb ? true : false}
            helperText={formik.touched.suburb && formik.errors.suburb ? formik.errors.suburb : ""}
          />
        </div>
      </div>
      <div className="form-row mt-4">
        <div
          className={props.showExportBtn === true ? "form-group col-md-4" : "form-group col-md-6"}
        >
          <label>
            State <span className="error">*</span>
          </label>
          <TextField
            name="state"
            className="w-100"
            select
            value={formik.values.state}
            SelectProps={{
              native: true
            }}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.state && formik.errors.state ? true : false}
            helperText={formik.touched.state && formik.errors.state ? formik.errors.state : ""}
          >
            <option disabled>Select State</option>
            {props.states.map((state, i) => (<option key={i} value={state.stateId}>
              {state.stateId}
            </option>))}
          </TextField>
        </div>
        <div
          className={props.showExportBtn === true ? "form-group col-md-4" : "form-group col-md-6"}
        >
          <label>
            Postcode <span className="error">*</span>
          </label>
          <ICInput
            name="postCode"
            type="text"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.postCode}
            error={formik.touched.postCode && formik.errors.postCode ? true : false}
            helperText={formik.touched.postCode && formik.errors.postCode ? formik.errors.postCode : ""}
          />
        </div>
        <div
          className={props.showExportBtn === true ? "form-group col-md-4 mb-0" : "d-none"}
        >
          <Button
            className="insta-button-primary ml-0 mr-2 mt-4 mb-1 float-left"
            title="Monthly Summary"
            type="button"
            clickEvent={props.exportMonthlySummary}
          ></Button>
          <Button
            className="insta-button-primary ml-0 mr-2 mt-4"
            title="Medicare Audit"
            type="button"
            clickEvent={props.exportMonthlyConsult}
          ></Button>
        </div>
        {/* <div
            className={
              props.showExportBtn === true
                ? "form-group col-md-2 mb-0"
                : "d-none"
            }
          >
             <Button
              className="insta-button-primary ml-0 mr-2 mt-4 mx-auto"
              title="Monthly DB4 Forms"
              type="button"
              clickEvent={props.exportDB4FormsSummary}
            ></Button>
          </div> */}
        {/* <div
            className={
              props.showExportBtn === true
                ? "form-group col-md-3 mb-0"
                : "d-none"
            }
          >
           
          </div> */}
      </div>
      {props.isApprovedProfile && (<React.Fragment>
        <p className="mt-4 mb-2">
          <b>Emergency Contact 1</b>
        </p>
        <div className="form-row">
          <div className="form-group col-md-6">
            <label>Contact Name</label>
            <ICInput
              name="contactName1"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.contactName1}
              error={formik.touched.contactName1 && formik.errors.contactName1 ? true : false}
              helperText={formik.touched.contactName1 && formik.errors.contactName1 ? formik.errors.contactName1 : ""}
            />
          </div>
          <div className="form-group col-md-6">
            <label>Contact Number</label>
            <ICPhoneInput
              name="contactNo1"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.contactNo1}
              error={formik.touched.contactNo1 && formik.errors.contactNo1 ? true : false}
              helperText={formik.touched.contactNo1 && formik.errors.contactNo1 ? formik.errors.contactNo1 : ""}
              disabled={false}
            />
          </div>
        </div>
        <p className="mt-4 mb-2">
          <b>Emergency Contact 2</b>
        </p>
        <div className="form-row">
          <div className="form-group col-md-6">
            <label>Contact Name</label>
            <ICInput
              name="contactName2"
              type="text"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.contactName2}
              error={formik.touched.contactName2 && formik.errors.contactName2 ? true : false}
              helperText={formik.touched.contactName2 && formik.errors.contactName2 ? formik.errors.contactName2 : ""}
            />
          </div>
          <div className="form-group col-md-6">
            <label>Contact Number</label>
            <ICPhoneInput
              name="contactNo2"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.contactNo2}
              error={formik.touched.contactNo2 && formik.errors.contactNo2 ? true : false}
              helperText={formik.touched.contactNo2 && formik.errors.contactNo2 ? formik.errors.contactNo2 : ""}
              disabled={false}
            />
          </div>
        </div>
      </React.Fragment>)}
      <div className="form-row mt-4">
        <div className="form-group col-md-6">
          <label>Profile Pic</label>
          <div className="d-flex flex-row">
            <DocImgView
              clickEvent={() => {
                setPicModalTitle("View Profile Pic");
                showSelPicModal(formik.values.profilePic);
              }}
              className="rounded-circle user-img pointer-cursor mr-4"
              pic={formik.values.profilePic}
            />
            &nbsp;&nbsp;
            <p>
              <input
                className="mb-2 pt-3"
                name="profilePicFile"
                type="file"
                onChange={event => {
                  if (validateFile(event.currentTarget.files[0], "profilePicFile")) {
                    formik.setFieldValue("profilePicFile", event.currentTarget.files[0]);

                    formik.setFieldValue("profilePic", previewUploadDoc(event.currentTarget.files[0]));
                  }
                }}
              />
              <br />
              <span style={{ fontSize: "12px" }}>
                  JPG, SVG or PNG. Max size of 2MB
                </span>
              <br />
              <Error>{profilePicFileErr}</Error>
            </p>
          </div>
        </div>
        <div className="form-group col-md-6">
          <label>Photo ID</label>
          <div className="d-flex flex-row">
            <DocImgView
              clickEvent={() => {
                setPicModalTitle("View Photo ID");
                showSelPicModal(formik.values.photoId);
              }}
              className="rounded-0 user-img pointer-cursor mr-4"
              pic={formik.values.photoId}
            />
            &nbsp;&nbsp;
            <p>
              <input
                className="mb-2 pt-3"
                name="photoIdFile"
                type="file"
                onChange={event => {
                  if (validateFile(event.currentTarget.files[0], "photoIdFile")) {
                    formik.setFieldValue("photoIdFile", event.currentTarget.files[0]);

                    formik.setFieldValue("photoId", previewUploadDoc(event.currentTarget.files[0]));
                  }
                }}
              />
              <br />
              <span style={{ fontSize: "12px" }}>
                  JPG, SVG or PNG. Max size of 2MB
                </span>
              <br />
              <Error>{photoIdFileErr}</Error>
            </p>
          </div>
        </div>
      </div>
      <div className="form-row mt-4">
        <div className="form-group col-md-6">
          <label>
            ABN <span className="error">*</span>
          </label>
          <ICMaskInput
            name="abn"
            type="text"
            mask="99 999 999 999"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.abn}
            error={formik.touched.abn && formik.errors.abn ? true : false}
            helperText={formik.touched.abn && formik.errors.abn ? formik.errors.abn : ""}
          />
        </div>
        <div className="form-group col-md-6">
          <label>ABN Doc</label>
          <div className="d-flex flex-row pl-2">
            <DocImgView
              clickEvent={() => {
                setPicModalTitle("View ABN");
                showSelPicModal(formik.values.abnFile);
              }}
              className="rounded-0 user-img pointer-cursor mr-4"
              pic={formik.values.abnFile}
              picName={formik.values.abnFileName}
            />
            &nbsp;&nbsp;
            <p>
              <input
                className="mb-2 ml-3"
                name="abnDocFile"
                type="file"
                onChange={event => {
                  if (validateFile(event.currentTarget.files[0], "abnDocFile", true)) {
                    formik.setFieldValue("abnDocFile", event.currentTarget.files[0]);

                    formik.setFieldValue("abnFile", previewUploadDoc(event.currentTarget.files[0]));
                    formik.setFieldValue("abnFileName", event.currentTarget.files[0].name);
                  }
                }}
              />
              <br />
              <span style={{ fontSize: "12px" }}>
                  JPG, SVG ,PNG or PDF. Max size of 2MB
                </span>
              <br />
              <Error>{abnDocFileErr}</Error>
            </p>
          </div>
        </div>
      </div>
      <div className="form-row mt-4">
        <div className="form-group col-md-6">
          <label>
            Australian Health Practitioners Regulation Agency (AHPRA)
            Registration <span className="error">*</span>
          </label>
          <ICInput
            name="ahp"
            type="text"
            value={formik.values.ahp}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.ahp && formik.errors.ahp ? true : false}
            helperText={formik.touched.ahp && formik.errors.ahp ? formik.errors.ahp : ""}
          />
        </div>
        <div className="form-group col-md-6">
          <label>
            Australian Health Practitioners Regulation Agency (AHPRA)
            Registration Doc
          </label>
          <div className="d-flex flex-row pl-2">
            <DocImgView
              clickEvent={() => {
                setPicModalTitle("View AHPRA");
                showSelPicModal(formik.values.ahpFile);
              }}
              className="rounded-0 user-img pointer-cursor mr-4"
              pic={formik.values.ahpFile}
              picName={formik.values.ahpFileName}
            />
            &nbsp;&nbsp;
            <p>
              <input
                className="mb-2 pt-3 ml-3"
                name="ahpDocFile"
                type="file"
                onChange={event => {
                  if (validateFile(event.currentTarget.files[0], "ahpDocFile", true)) {
                    formik.setFieldValue("ahpDocFile", event.currentTarget.files[0]);

                    formik.setFieldValue("ahpFile", previewUploadDoc(event.currentTarget.files[0]));
                    formik.setFieldValue("ahpFileName", event.currentTarget.files[0].name);
                  }
                }}
              />
              <br />
              <span style={{ fontSize: "12px" }}>
                  JPG, SVG, PNG or PDF. Max size of 2MB
                </span>
              <br />
              <Error>{ahpDocFileErr}</Error>
            </p>
          </div>
        </div>
      </div>
      <div className="form-row mt-4">
        <div className="form-group col-md-6">
          <label>
            Medicare Provider Number <span className="error">*</span>
          </label>
          <ICInput
            name="medProvNo"
            type="text"
            value={formik.values.medProvNo}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.medProvNo && formik.errors.medProvNo ? true : false}
            helperText={formik.touched.medProvNo && formik.errors.medProvNo ? formik.errors.medProvNo : ""}
          />
        </div>
        <div className="form-group col-md-6">
          <label>Medicare Provider Number Doc</label>
          <div className="d-flex flex-row">
            <DocImgView
              clickEvent={() => {
                setPicModalTitle("View Medical Provider Number Pic");
                showSelPicModal(formik.values.medProNoFile);
              }}
              className="rounded-0 user-img pointer-cursor mr-4"
              pic={formik.values.medProNoFile}
              picName={formik.values.medProNoFileName}
            />
            &nbsp;&nbsp;
            <p>
              <input
                className="mb-2 pt-3"
                type="file"
                name="medProNoDocFile"
                onChange={event => {
                  if (validateFile(event.currentTarget.files[0], "medProNoDocFile", true)) {
                    formik.setFieldValue("medProNoDocFile", event.currentTarget.files[0]);

                    formik.setFieldValue("medProNoFile", previewUploadDoc(event.currentTarget.files[0]));
                    formik.setFieldValue("medProNoFileName", event.currentTarget.files[0].name);
                  }
                }}
              />
              <br />
              <span style={{ fontSize: "12px" }}>
                  JPG, SVG, PNG or PDF. Max size of 2MB
                </span>
              <br />
              <Error>{medProNoDocFileErr}</Error>
            </p>
          </div>
        </div>
      </div>


      <div className="form-row mt-4">
        <div className="form-group col-md-6">
          <label>
            Prescriber Number
            <span className="error">*</span>
          </label>
          <ICInput
            name="presNo"
            type="text"
            value={formik.values.presNo}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.presNo && formik.errors.presNo ? true : false}
            helperText={formik.touched.presNo && formik.errors.presNo ? formik.errors.presNo : ""}
          />
        </div>
        <div className="form-group col-md-6">
          <label>Prescriber Number Doc</label>
          <div className="d-flex flex-row pl-2">
            <DocImgView
              clickEvent={() => {
                setPicModalTitle("View Prescriber Number Pic");
                showSelPicModal(formik.values.pndFile);
              }}
              className="rounded-0 user-img pointer-cursor mr-4"
              pic={formik.values.pndFile}
              picName={formik.values.pndFileName}
            />
            &nbsp;&nbsp;
            <p>
              <input
                className="mb-2 pt-3 ml-3"
                type="file"
                name="pndDocFile"
                onChange={event => {
                  if (validateFile(event.currentTarget.files[0], "pndDocFile", true)) {
                    formik.setFieldValue("pndDocFile", event.currentTarget.files[0]);

                    formik.setFieldValue("pndFile", previewUploadDoc(event.currentTarget.files[0]));
                    formik.setFieldValue("pndFileName", event.currentTarget.files[0].name);
                  }
                }}
              />
              <br />
              <span style={{ fontSize: "12px" }}>
                  JPG, SVG, PNG or PDF. Max size of 2MB
                </span>
              <br />
              <Error>{pndDocFileErr}</Error>
            </p>
          </div>
        </div>
      </div>

      <div className="form-row mt-4">
        <div className="form-group col-md-6">
          <label>
            Authorised Prescriber Scheme Prescriber Number (Smoking Cessation)
          </label>
          <ICInput
            name="authPrescriberSchemaNo"
            type="text"
            value={formik.values.authPrescriberSchemaNo}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.authPrescriberSchemaNo && formik.errors.authPrescriberSchemaNo ? true : false}
            helperText={formik.touched.authPrescriberSchemaNo && formik.errors.authPrescriberSchemaNo ? formik.errors.authPrescriberSchemaNo : ""}
          />
        </div>

        <div className="form-group col-md-6">
          <label>Authorised Prescriber Scheme Prescriber Number Doc</label>
          <div className="d-flex flex-row pl-2">
            <DocImgView
              clickEvent={() => {
                setPicModalTitle("View Prescriber Number Pic");
                showSelPicModal(formik.values.AUTH_PRESCRIBER_SCHEMA_DOC);
              }}
              className="rounded-0 user-img pointer-cursor mr-4"
              pic={formik.values.AUTH_PRESCRIBER_SCHEMA_DOC}
              picName={formik.values.AUTH_PRESCRIBER_SCHEMA_DOC_NAME}
            />
            &nbsp;&nbsp;
            <p>
              <input
                className="mb-2 pt-3 ml-3"
                type="file"
                name="AUTH_PRESCRIBER_SCHEMA_DOCDoc"
                onChange={event => {
                  if (validateFile(event.currentTarget.files[0], "AUTH_PRESCRIBER_SCHEMA_DOCDoc", true)) {
                    formik.setFieldValue("AUTH_PRESCRIBER_SCHEMA_DOCDoc", event.currentTarget.files[0]);

                    formik.setFieldValue("AUTH_PRESCRIBER_SCHEMA_DOC", previewUploadDoc(event.currentTarget.files[0]));
                    formik.setFieldValue("AUTH_PRESCRIBER_SCHEMA_DOC_NAME", event.currentTarget.files[0].name);
                  }
                }}
              />
              <br />
              <span style={{ fontSize: "12px" }}>
                  JPG, SVG, PNG or PDF. Max size of 2MB
                </span>
              <br />
              <Error>{AUTH_PRESCRIBER_SCHEMA_DOCDocErr}</Error>
            </p>
          </div>
        </div>
      </div>


      <div className="form-row mt-4">
        <div className="form-group col-md-6">
          <label>
            Authorised Prescriber Scheme Prescriber Number (Medicinal Cannabis)
          </label>
          <ICInput
            name="authPrescriberSchemaNoMC"
            type="text"
            value={formik.values.authPrescriberSchemaNoMC}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.authPrescriberSchemaNoMC && formik.errors.authPrescriberSchemaNoMC ? true : false}
            helperText={formik.touched.authPrescriberSchemaNoMC && formik.errors.authPrescriberSchemaNoMC ? formik.errors.authPrescriberSchemaNoMC : ""}
          />
        </div>

        <div className="form-group col-md-6">
          <label>Authorised Prescriber Scheme Prescriber Number Doc</label>
          <div className="d-flex flex-row pl-2">
            <DocImgView
              clickEvent={() => {
                setPicModalTitle("View Prescriber Number Pic");
                showSelPicModal(formik.values.AUTH_PRESCRIBER_SCHEMA_DOC_MC);
              }}
              className="rounded-0 user-img pointer-cursor mr-4"
              pic={formik.values.AUTH_PRESCRIBER_SCHEMA_DOC_MC}
              picName={formik.values.AUTH_PRESCRIBER_SCHEMA_DOC_NAME_MC}
            />
            &nbsp;&nbsp;
            <p>
              <input
                className="mb-2 pt-3 ml-3"
                type="file"
                name="AUTH_PRESCRIBER_SCHEMA_DOCDoc_MC"
                onChange={event => {
                  if (validateFile(event.currentTarget.files[0], "AUTH_PRESCRIBER_SCHEMA_DOCDoc_MC", true)) {
                    formik.setFieldValue("AUTH_PRESCRIBER_SCHEMA_DOCDoc_MC", event.currentTarget.files[0]);

                    formik.setFieldValue("AUTH_PRESCRIBER_SCHEMA_DOC_MC", previewUploadDoc(event.currentTarget.files[0]));
                    formik.setFieldValue("AUTH_PRESCRIBER_SCHEMA_DOC_NAME_MC", event.currentTarget.files[0].name);
                  }
                }}
              />
              <br />
              <span style={{ fontSize: "12px" }}>
                  JPG, SVG, PNG or PDF. Max size of 2MB
                </span>
              <br />
              <Error>{AUTH_PRESCRIBER_SCHEMA_DOCDocMCErr}</Error>
            </p>
          </div>
        </div>
      </div>

      <div className="form-row mt-4">
        <div className="form-group col-md-6">
          <label>
            eRx ID
            <span className="error">*</span>
          </label>
          <ICInput
            name="eRxId"
            type="text"
            value={formik.values.eRxId}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.eRxId && formik.errors.eRxId ? true : false}
            helperText={formik.touched.eRxId && formik.errors.eRxId ? formik.errors.eRxId : ""}
          />
        </div>
        <div className="form-group col-md-6">
          <label>eRx ID Doc</label>
          <div className="d-flex flex-row pl-2">
            <DocImgView
              clickEvent={() => {
                setPicModalTitle("View eRx Pic");
                showSelPicModal(formik.values.eRxFile);
              }}
              className="rounded-0 user-img pointer-cursor mr-4"
              pic={formik.values.eRxFile}
              picName={formik.values.eRxFileName}
            />
            &nbsp;&nbsp;
            <p>
              <input
                className="mb-2 pt-3 ml-3"
                type="file"
                name="eRxDocFile"
                onChange={event => {
                  if (validateFile(event.currentTarget.files[0], "eRxDocFile", true)) {
                    formik.setFieldValue("eRxDocFile", event.currentTarget.files[0]);

                    formik.setFieldValue("eRxFile", previewUploadDoc(event.currentTarget.files[0]));
                    formik.setFieldValue("eRxFileName", event.currentTarget.files[0].name);
                  }
                }}
              />
              <br />
              <span style={{ fontSize: "12px" }}>
                  JPG, SVG, PNG or PDF. Max size of 2MB
                </span>
              <br />
              <Error>{eRxDocFileErr}</Error>
            </p>
          </div>
        </div>
      </div>
      <div className="form-row mt-4">
        <div className="form-group col-md-6">
          <label>
            Professional Indemnity Insurance Policy
            <span className="error">*</span>
          </label>
          <ICInput
            name="piip"
            type="text"
            value={formik.values.piip}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.piip && formik.errors.piip ? true : false}
            helperText={formik.touched.piip && formik.errors.piip ? formik.errors.piip : ""}
          />
        </div>
        <div className="form-group col-md-6">
          <label>Professional Indemnity Insurance Policy Doc</label>
          <div className="d-flex flex-row pl-2">
            <DocImgView
              clickEvent={() => {
                setPicModalTitle("View Professional Indemnity Insurance Policy Pic");
                showSelPicModal(formik.values.piipdFile);
              }}
              className="rounded-0 user-img pointer-cursor mr-4"
              pic={formik.values.piipdFile}
              picName={formik.values.piipdFileName}
            />
            &nbsp;&nbsp;
            <p>
              <input
                className="mb-2 pt-3 ml-3"
                type="file"
                name="piipdDocFile"
                onChange={event => {
                  if (validateFile(event.currentTarget.files[0], "piipdDocFile", true)) {
                    formik.setFieldValue("piipdDocFile", event.currentTarget.files[0]);

                    formik.setFieldValue("piipdFile", previewUploadDoc(event.currentTarget.files[0]));
                    formik.setFieldValue("piipdFileName", event.currentTarget.files[0].name);
                  }
                }}
              />
              <br />
              <span style={{ fontSize: "12px" }}>
                  JPG, SVG, PNG or PDF. Max size of 2MB
                </span>
              <br />
              <Error>{piipdDocFileErr}</Error>
            </p>
          </div>
        </div>
      </div>
      <div className="form-row mt-4">
        <div className="form-group col-md-6">
          <label>HPII Number</label>
          <ICInput
            name="HPIINumber"
            type="text"
            disabled
            value={formik.values.HPIINumber}
            onChange={formik.handleChange}
          />
          {formik.values.HPIIUpdatedAt && (<span className="text-success" style={{ fontSize: "12px" }}>
                Updated{" "}
            {new Date(formik.values.HPIIUpdatedAt).toLocaleString("es-CL")}
              </span>)}
        </div>
        <div className="form-group col-md-6">
          <label>
            Signature <span className="error">*</span>
          </label>
          <div className="d-flex flex-row">
            <DocImgView
              clickEvent={() => {
                setPicModalTitle("View Signature");
                showSelPicModal(formik.values.sigatureFile);
              }}
              className="rounded-0 user-img pointer-cursor mr-4"
              pic={formik.values.sigatureFile}
            />
            &nbsp;&nbsp;
            <p>
              <input
                className="mb-2 pt-3"
                type="file"
                name="sigatureDocFile"
                onChange={event => {
                  if (validateFile(event.currentTarget.files[0], "sigatureDocFile")) {
                    formik.setFieldValue("sigatureDocFile", event.currentTarget.files[0]);

                    formik.setFieldValue("sigatureFile", previewUploadDoc(event.currentTarget.files[0]));
                  }
                }}
              />
              <br />
              <span style={{ fontSize: "12px" }}>
                  JPG, SVG, PNG. Max size of 2MB
                </span>
              <br />
              <Error>{sigatureDocFileErr}</Error>
            </p>
          </div>
        </div>
      </div>
      <div className="form-row mt-4">
        <div className="form-group col-md-6">
          <div className="form-row">
            <div className="form-group col-6">
              <label>HPII Status</label>
              <ICInput
                name="HPIIStatus"
                type="text"
                disabled
                value={formik.values.HPIIStatus}
                onChange={formik.handleChange}
              />
            </div>
            <div className="form-group col-1">
              <RefreshButton
                onClick={() => checkDuplicateDoctorDemographicInfo(formik.values)}
              />
            </div>
            <div className="form-group col-2">
              <HistoryRecordButton onClick={() => showHPIIHistory()} />
            </div>
          </div>
        </div>
        <div className="form-group col-md-6">
          <label>
            Signed Service Agreement <span className="error">*</span>
          </label>
          <div className="d-flex flex-row pl-2">
            <DocImgView
              clickEvent={() => {
                setPicModalTitle("View Signed Service Agreement");
                showSelPicModal(formik.values.ssaFile);
              }}
              className="rounded-0 user-img pointer-cursor mr-4"
              pic={formik.values.ssaFile}
              picName={formik.values.ssaFileName}
            />
            &nbsp;&nbsp;
            <p>
              <input
                className="mb-2 pt-3 ml-3"
                type="file"
                name="ssaDocFile"
                onChange={event => {
                  if (validateFile(event.currentTarget.files[0], "ssaDocFile", true)) {
                    formik.setFieldValue("ssaDocFile", event.currentTarget.files[0]);

                    formik.setFieldValue("ssaFile", previewUploadDoc(event.currentTarget.files[0]));
                    formik.setFieldValue("ssaFileName", event.currentTarget.files[0].name);
                  }
                }}
              />
              <br />
              <span style={{ fontSize: "12px" }}>
                  JPG, SVG, PNG or PDF. Max size of 2MB
                </span>
              <br />
              <Error>{ssaDocFileErr}</Error>
            </p>
          </div>
        </div>
      </div>
      {/*
        <div className="form-row mt-4">
          <div className="form-group col-md-6">
            <div className="form-row">
              <div className="form-group col-6">
                <label>PIN Number</label>
                <span className="error">*</span>
                <ICInput
                  name="pin"
                  type="text"
                  value={formik.values.pin}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.pin && formik.errors.pin ? true : false}
                  helperText={
                    formik.touched.pin && formik.errors.pin
                      ? formik.errors.pin
                      : ""
                  }
                />
              </div>
            </div>
          </div>
          <div className="form-group col-md-6">
            <div className="form-row">
              <div className="form-group col-5">
                <label>Reset Password Fail Counter</label>
                <ICInput
                  name="passwordFailCounter"
                  type="text"
                  disabled
                  value={formik.values.passwordFailCounter}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.passwordFailCounter &&
                    formik.errors.passwordFailCounter
                      ? true
                      : false
                  }
                  helperText={
                    formik.touched.passwordFailCounter &&
                    formik.errors.passwordFailCounter
                      ? formik.errors.passwordFailCounter
                      : ""
                  }
                />
              </div>
              <div className="form-group col-1">
                <RefreshButton
                  onClick={() => {
                    formik.values.passwordFailCounter = "0";
                    setPasswordFailCounter("0");
                  }}
                />
              </div>
            </div>
          </div>
        </div>
 */}
      <div className="form-row mt-4">
        {formik.values.isAccessToInstantSwitch && <div className="form-group col-md-6">
          <label>Instant Switch Bio</label>
          <TextField
            name="instantSwitchBio"
            className="w-100 dynamic-textarea"
            multiline
            value={formik.values.instantSwitchBio}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.instantSwitchBio && formik.errors.instantSwitchBio ? true : false}
            helperText={formik.touched.instantSwitchBio && formik.errors.instantSwitchBio ? formik.errors.instantSwitchBio : ""}
          />
        </div>}
        {formik.values.isAccessToInstantSwitchMC && <div className="form-group col-md-6">
          <label>Instant Leaf Bio</label>
          <TextField
            name="instantLeafBio"
            className="w-100 dynamic-textarea"
            multiline
            value={formik.values.instantLeafBio}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.instantLeafBio && formik.errors.instantLeafBio ? true : false}
            helperText={formik.touched.instantLeafBio && formik.errors.instantLeafBio ? formik.errors.instantLeafBio : ""}
          />
        </div>}
        {formik.values.isAccessToInstantHush && <div className="form-group col-md-6">
          <label>Instant Hush Bio</label>
          <TextField
            name="instantHushBio"
            className="w-100 dynamic-textarea"
            multiline
            value={formik.values.instantHushBio}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.instantHushBio && formik.errors.instantHushBio ? true : false}
            helperText={formik.touched.instantHushBio && formik.errors.instantHushBio ? formik.errors.instantHushBio : ""}
          />
        </div>
        }
      </div>
      <div className="form-row mt-4">
        <div
          className={props.isRejectedProfile || props.isApprovedProfile ? "form-group col-md-6" : "form-group col-md-12"}
        >
          <label>Additional Notes from Application</label>
          <TextField
            name="additionalApplication"
            className="w-100 dynamic-textarea"
            multiline
            value={formik.values.additionalApplication}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={props.isRejectedProfile || props.isApprovedProfile ? true : false}
            error={formik.touched.additionalApplication && formik.errors.additionalApplication ? true : false}
            helperText={formik.touched.additionalApplication && formik.errors.additionalApplication ? formik.errors.additionalApplication : ""}
          />
        </div>
        {(props.isRejectedProfile || props.isApprovedProfile) && (<div className="form-group col-md-6">
          <label>Additional Notes Regarding This Doctor</label>
          <TextField
            name="addNoForDoctor"
            className="w-100 dynamic-textarea"
            multiline
            value={formik.values.addNoForDoctor}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.addNoForDoctor && formik.errors.addNoForDoctor ? true : false}
            helperText={formik.touched.addNoForDoctor && formik.errors.addNoForDoctor ? formik.errors.addNoForDoctor : ""}
          />
        </div>)}
        {props.isApprovedProfile && (<div className="form-group col-md-6">
          <ICCheckbox
            //style={{ padding: 0 }}
            name="optOutMarketingEmails"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.optOutMarketingEmails}
            checked={formik.values.optOutMarketingEmails}
            label="Opt-Out Marketing Emails"
            inputProps={{ "aria-label": "primary checkbox" }}
          />
        </div>)}
      </div>
      <br />
      <p className="mb-0 d-flex justify-content-center">
        <Button title="Save" type="submit" />
        <Button
          className="insta-button-primary ml-3 mr-3 mb-4"
          title="Cancel"
          type="button"
          clickEvent={handleClickCancel}
        ></Button>
      </p>
    </form>
    {/* API Call */}
    <MakeAPICall apiParam={apiCallParams} />
  </Fragment>);
};

export default DoctorProfileForm;

DoctorProfileForm.defaultProps = {
  isRejectedProfile: false, isApprovedProfile: false, data: null, states: []
};

DoctorProfileForm.propTypes = {
  isRejectedProfile: PropTypes.bool,
  isApprovedProfile: PropTypes.bool,
  data: PropTypes.object,
  states: PropTypes.array,
  onSubmitForm: PropTypes.func,
  onCancelForm: PropTypes.func
};
